import React from 'react';
import PropTypes from 'prop-types';
import { formStyleConstants } from '../utils/constants/form-style-constants';
import { getDestructuredTextWithMultipleLinks } from '../../../../general/js/utils';

function FormPolicy({
    policy,
    isHidden,
    showConsent,
    consentLabel,
    policyName,
    onChange,
    validState,
    defaultValue
}) {
    const { isValid, errorMessage } = validState || { isValid: true };
    if (isHidden) {
        return null;
    }

    return (
        <div className='form-checkbox-panel'>
            <h5 className='form-checkbox-panel__title'>
                {getDestructuredTextWithMultipleLinks(
                    policy.label,
                    policy.link.split(';')
                )}
            </h5>

            { showConsent ?
                <div className={`form-checkbox form-checkbox-panel__container ${!isValid ? formStyleConstants.isInvalid : ''}`}>
                    <label className="form-switch">
                        <input
                            type='checkbox'
                            className='form-checkbox__checkbox visually-hidden'
                            name={policyName}
                            id={policyName}
                            onChange={onChange}
                            defaultChecked={defaultValue}
                        /><i></i>{consentLabel}
                    </label>
                    {!isValid ? <ul className="form-field__error-list filled">
                        <li className="form-field__error-item">{errorMessage}</li>
                    </ul> : null}
                </div> : null}
        </div>
    );
}

FormPolicy.propTypes = {
    policy: PropTypes.object.isRequired,
    consentLabel: PropTypes.string.isRequired,
    policyName: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    validState: PropTypes.object
};

export default FormPolicy;
